exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Billing-4df6c6d3{max-width:1200px;padding:50px 100px}.header-80933ac5{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:40px}.backButton-ca37460e{display:block;padding-bottom:20px}.quickStats-89bedb89{width:600px;margin-bottom:0px}.cardHeader-667b4858{display:flex;justify-content:space-between;margin-bottom:10px}a.aSpecificity-5cd661ad{max-width:180px;max-height:50px}a.aSpecificity-5cd661ad>span{margin-right:10px}.guestsTable-369da74b{width:100%;border-collapse:collapse}.guestsTable-369da74b thead{background-color:#eee}.guestsTable-369da74b th{font-weight:500;font-size:14px;line-height:20px;padding:10px 20px;text-align:left}.guestsTable-369da74b td{border:1px solid #e0e0e0;padding:10px 20px}\n", ""]);

// Exports
exports.locals = {
	"Billing": "Billing-4df6c6d3",
	"header": "header-80933ac5",
	"backButton": "backButton-ca37460e",
	"quickStats": "quickStats-89bedb89",
	"cardHeader": "cardHeader-667b4858",
	"aSpecificity": "aSpecificity-5cd661ad",
	"guestsTable": "guestsTable-369da74b"
};